module.exports = __webpack_public_path__ + "img/logo.3840b53e.png";